export default __webpack_public_path__ + "static/media/itempage-image-3.c5c91589.jpg";